var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadTranscriptIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4562 4H6.29125C5.94879 4 5.62035 4.13604 5.3782 4.3782C5.13604 4.62035 5 4.94879 5 5.29125V15.6212C5 15.9637 5.13604 16.2921 5.3782 16.5343C5.62035 16.7764 5.94879 16.9125 6.29125 16.9125H14.0387C14.3812 16.9125 14.7096 16.7764 14.9518 16.5343C15.1939 16.2921 15.33 15.9637 15.33 15.6212V7.87375L11.4562 4Z",
    stroke: "black",
    strokeWidth: 1.29125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4563 4V7.87375H15.33",
    stroke: "black",
    strokeWidth: 1.29125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7475 11.1019H7.58255",
    stroke: "black",
    strokeWidth: 1.29125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3272 13.6844H7.58255",
    stroke: "black",
    strokeWidth: 1.29125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8738 8.51935H8.22817H7.58255",
    stroke: "black",
    strokeWidth: 1.29125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.2428L14.835 16.0777L15.67 15.2427",
    stroke: "#22CE29",
    strokeWidth: 0.485068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.835 16.0777V13.9999",
    stroke: "#22CE29",
    strokeWidth: 0.485068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTranscriptIc);
export default __webpack_public_path__ + "static/media/download_transcript_ic.093c716f463c5a3c441d720967c68ab2.svg";
export { ForwardRef as ReactComponent };